export default {
  course: 'Guideline',
  baseinfo: {
    datasource: 'Data source',
    fileformat: 'File format',
    other: 'Other',
    otherformat: 'Please enter file format',
    maxwidth: 'Max width',
    maxheight: 'Max height',
    minwidth: 'Min width',
    minheight: 'Min height',
    note: 'Notes',
    skill: 'Skills needed by collectors or annotators',
    ski: 'Skills needed',
    dataqualified: 'Data standard',
    qualified: 'Eligibility criteria',
    valcriterion: 'Validity criteria',
    criterion: 'Judgement standard',
    js: {
      rules: {
        maxWidth: 'Please enter max width ',
        maxHeight: 'Please enter max height',
        minWidth: 'Please enter min width',
        minHeight: 'Please enter min height',
        format: 'Please choose at least one file format',
        formatOther: 'Please enter file format',
        qualified: 'Please enter eligibility criteria',
        skill: 'Please enter skills needed',
        criterion: 'Please enter validity criteria'
      }
    }
  },
  business: {
    wholemap: 'Integral image ',
    singlechoice: 'Single choice',
    multiplechoice: 'Multiple choice',
    fillblank: 'Gap filling',
    labelproblem: 'Item label',
    entercontent: 'Please enter',
    preview: 'Preview template',
    rectChoice: 'Box selection settings (unit: pixels)',
    rectMinW: 'Min length ',
    rectMinH: 'Min width',
    rectMinArea: 'Min area',
    rectNote1: 'You can set the size of the box, and the rectangular size that the annotator annotates cannot be smaller than the parameter you set.',
    rectNote2: 'Default size: the minimum length is 5px, the minimum width is 5px, and the minimum area is 20px.',
    taskintro: 'Task introduction',
    taskbref: 'Brief introduction',
    tasktime: 'Task schedule',
    starttime: 'Time period',
    to: 'To',
    startdate: 'Starting time',
    stopdate: 'Ending time',
    unsatisfy: 'Unsatisfied about the module?',
    service: 'Get my customized service!',
    js: {
      rules: {
        brief1: 'Please enter brief introduction ',
        brief2: 'The length is limited within 128 characters',
        introduce1: 'Please enter task introduction ',
        introduce2: 'The length is limited within 10,000 characters',
        date1: 'Please choose time period'
      },
      title: 'Title',
      label: 'Choice',
      labelContent: 'Meaning of choices',
      text: 'Gap filling '
    }
  },
  qcprice: {
    datascale: 'Data scale',
    picturenum: 'Image amount',
    zhang: '',
    picturequality: 'Image quality',
    selectpicquality: 'Please choose',
    estimate: 'Estimated time ',
    minute: 'Minutes (time for annotate one image',
    qualitytest: 'Quality inspection method ',
    qualitytest2: 'Method',
    selectquatest: 'Please choose',
    priceratio: 'QI price percent',
    scale: ' (Quality inspection price/Task price)',
    checkrate: 'QI percent',
    spotnumber: 'Inspection frequency',
    taskprice: 'Inspection unit price',
    integral: ' Credits/image',
    total: 'Accumulated answer ',
    checktimes: 'Inspection frequency ',
    time: 'Times',
    checknumber: 'Inspection amount ',
    perzhang: '个/张',
    moreamount: '人/张（每张数据最多多少人做）',
    labelnum: 'Number of annotators',
    leastlabel: 'At least annotate',
    morelabel: 'At most annotate',
    rate: 'Percent',
    expectlabel: 'Estimated annotate',
    quote: 'Price',
    quotenote: '如果您愿意给到标注员100泛函币作为劳动报酬，泛函将额外收取30泛函币作为平台服务费，您总共需要支付130泛函币。',
    suggestprice: 'Suggested price',
    leastprice: 'Lowest price',
    unitprice: 'Annotation unit price',
    totalprice: 'Total price of quality inspection',
    sumprice: 'Total price',
    inter: ' Credits',
    leftpart: '【',
    rightpart: '】',
    js: {
      rules: {
        num1: 'Please enter amount',
        num2: 'The amount must be a number',
        scale1: 'Please enter data size',
        scale2: 'The data size must be a number',
        thisQuality: 'Please choose image quality ',
        taskTime1: 'Please enter estimated time',
        taskTime2: 'Estimated time must be a number',
        checkType: 'Please choose quality inspection method',
        checkProportion1: 'Please enter',
        checkProportion2: 'Must be a number',
        spotCheck1: 'Please enter quality inspection percent',
        spotCheck2: 'Quality inspection percent must be a number',
        allCheckNum1: 'Please enter inspection times',
        allCheckNum2: 'Inspection time must be a number',
        rightAnswer1: 'Please enter',
        rightAnswer2: 'Must be a number',
        tagNumber1: 'Please enter annotator number',
        tagNumber2: 'Annotator number must be a number',
        goldTest1: 'Please enter',
        goldTest2: 'Must be a number',
        offer1: 'Please enter price',
        offer2: 'Price must be a number'
      }
    }
  },
  sample: {
    name: 'Name',
    describe: 'Description',
    exampledata: 'Sample',
    selectexamdata: 'Choose',
    uploadnewfile: 'Upload a new file',
    confirm: 'Confirm',
    reset: 'Cancellation',
    filename: 'File name',
    filesize: 'Size',
    operate: 'Operate',
    remove: 'Remove',
    lessupload: 'Audio only, max 20Mb',
    clickupload: 'Click to upload ',
    save: 'Save',
    trueexample: 'Correct list of samples',
    addexample: 'Add a sample',
    delete: 'Delete ',
    errorexample: 'Incorrect list of samples',
    js: {
      rules: {
        name1: 'Please enter name ',
        name2: 'The length is limited from 1 to 10 characters ',
        selectExample: 'Please choose a sample '
      },
      addStatus: {
        type1: 'Edit answer ',
        type2: 'Add an answer'
      },
      success: {
        type1: 'Success',
        type2: 'Confirm',
        type3: 'Delete success',
        type4: 'Upload success',
        type5: 'Add success'
      },
      error: {
        type1: 'Failure',
        type2: 'Warning',
        type3: 'Cancellation',
        type4: 'Image uploading error, please refresh retry!',
        type5: 'Each user uploads up to 10 files at most!',
        type6: 'The upload size is too large'
      },
      deleteSampleFile: 'After the file is removed, the corresponding sample will be deleted. Do you want to continue?',
      deleteSampleItem: 'You are deleting the sample. Do you want to continue?'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/pushimage.js